import { URL_CREATE_NEW_JOB, URL_LIST_JOBS_DRAFT } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import { Stack, Text, TextLink } from 'braid-design-system';

import { ErrorSectionLayout } from 'src/app/v2/components/ErrorSectionLayout';
import { urlResolver } from 'src/app/v2/utils/getUrlResolver';

import translations from './.vocab';
import { UnrecoverableErrorSvg } from './UnrecoverableErrorSvg';

export const ErrorSectionUnrecoverable = () => {
  const { t } = useTranslations(translations);

  const createNewDraftUrl = urlResolver({ path: URL_CREATE_NEW_JOB });
  const draftListUrl = urlResolver({ path: URL_LIST_JOBS_DRAFT });

  return (
    <ErrorSectionLayout
      heading={t('error-section-unrecoverable-heading')}
      image={<UnrecoverableErrorSvg />}
    >
      <Stack space="xlarge" align="left">
        <Text>{t('error-section-unrecoverable-root-cause')}</Text>
        <Text>
          {t('error-section-unrecoverable-resolution', {
            ViewDraftsLink: (text: React.ReactNode[]) => (
              <TextLink href={draftListUrl} weight="weak">
                {text}
              </TextLink>
            ),
            CreateNewDraftUrl: (text: React.ReactNode[]) => (
              <TextLink href={createNewDraftUrl} weight="weak">
                {text}
              </TextLink>
            ),
          })}
        </Text>
      </Stack>
    </ErrorSectionLayout>
  );
};
